import { Tag } from "@chakra-ui/react";
import { ReactNode } from "react";

export const FilterTag: React.FC<{
  children: ReactNode;
  onClose: () => void;
}> = ({ children, onClose }) => {
  return (
    <Tag.Root py={1} fontSize="xs" cursor={"pointer"} onClick={onClose}>
      <Tag.StartElement>
        <Tag.CloseTrigger />
      </Tag.StartElement>
      <Tag.Label>{children}</Tag.Label>
    </Tag.Root>
  );
};
